import React from 'react';
import PropTypes from 'prop-types';
import css from './CwButton.scss';
import cx from 'classnames';
import CwImage from '../cwimage/CwImage';
import IconPath from 'src/utils/IconPath';

class CwButton extends React.Component {
  handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      if (this.props.onClick) {
        this.props.onClick();
      }
    }
    if (this.props.onKeyDown) {
      this.props.onKeyDown(e);
    }
  };

  handleKeyUp = (e) => {
    if (this.props.onKeyUp) {
      this.props.onKeyUp(e);
    }
  };

  focus = () => {
    this.cwButton.focus();
  };

  render() {

    const { isStandard, disabled, inAGrid } = this.props;

    const wrapClass = cx(
      css.wrap,
      this.props.className,
      {
        [css.topIcon]: this.props.topIcon
      });

    const btnClass = cx({
      [css.innerStandardDisabled]: isStandard && disabled && !inAGrid,
      [css.innerStandardActive]: isStandard && !disabled && !inAGrid,
      [css.innerLightDisabled]: !isStandard && disabled && !inAGrid,
      [css.innerLightActive]: !isStandard && !disabled && !inAGrid,
      [css.innerStandardDisabledGrid]: isStandard && disabled && inAGrid,
      [css.innerStandardActiveGrid]: isStandard && !disabled && inAGrid,
      [css.innerLightDisabledGrid]: !isStandard && disabled && inAGrid,
      [css.innerLightActiveGrid]: !isStandard && !disabled && inAGrid
    });

    const rightIconClass = cx({[css.rightIcon]: css.rightIcon});
    
    return (
      <div
        data-cwid={this.props.cwId}
        onBlur={this.props.onBlur}
        style={this.props.style}
        className={wrapClass}
        tabIndex={this.props.disabled ? -1 : this.props.tabIndex}
        onClick={this.props.disabled ? null : this.props.onClick}
        onKeyPress={this.props.disabled ? null : this.handleKeyPress}
        onKeyDown={this.props.disabled ? null : this.handleKeyDown}
        onKeyUp={this.props.disabled ? null : this.handleKeyUp}
        ref={(input) => this.cwButton = input}
        onFocus={this.props.onFocus}
        title={this.props.toolTip}
      >
        {this.props.topIcon ? <div className={cx({ [css.topIconClassDisabled]: disabled })}><CwImage src={this.props.topIcon} /></div> : null}
        <div className={btnClass}>
          {this.props.icon ? <CwImage src={this.props.icon} /> : null}
          {this.props.value}
          {this.props.rightIcon ? <CwImage className={rightIconClass} src={this.props.rightIcon} /> : null}
          {this.props.isMenu ? <CwImage src={this.props.menuIcon} /> : null}
        </div>
      </div>
    );
  };
}

CwButton.propTypes = {
  /**
   * Connectwise element id to be used as unique identifier
   */
  cwId: PropTypes.string,
  /**
   * Callback function that is fired when CwButton is focused
   */
  onFocus: PropTypes.func,
  /**
   * Callback function that is fired when CwButton is blurred
   */
  onBlur: PropTypes.func,
  /**
   * The css class name to be appended to default classname
   */
  className: PropTypes.string,
  /**
   * Used to control button height
   */
  height: PropTypes.number,
  /**
   * Optional icon placed on left side of button
   */
  icon: PropTypes.string,
  /**
   * Used to control if the button is standard or light
   */
  isStandard: PropTypes.bool,
  /**
   * Used to disable a button
   */
  disabled: PropTypes.bool,
  /**
   * Callback function fired when button is clicked
   */
  onClick: PropTypes.func,
  /**
   * Override the styles of the root element
   */
  style: PropTypes.object,
  /**
   * Used to control order when tabbing through items
   */
  tabIndex: PropTypes.number,
  /**
   * Button's text
   */
  value: PropTypes.string,
  /**
   * Callback function when key is down while component is focused/active
   */
  onKeyDown: PropTypes.func,
  /**
   * Callback function when key is up after being pressed down while component is focused/active
   */
  onKeyUp: PropTypes.func,
  /**
   * Optional icon placed on right side of button
   */
  rightIcon: PropTypes.string,
  /**
   * Optional icon placed on top of button
   */
  topIcon: PropTypes.string,
  /**
   * Button's tooltip text
   */
  toolTip: PropTypes.string,
  /**
   * If true, adds dropdown icon on right
   */
  isMenu: PropTypes.bool,
  /**
   * Optional dropdown icon placed on right side of button
   */
  menuIcon: PropTypes.string,
};

CwButton.defaultProps = {
  tabIndex: 0,
  menuIcon: IconPath.get('Action_Expand_Light')
};

export default CwButton;


// WEBPACK FOOTER //
// ./src/components/cwbutton/CwButton.jsx